import React from 'react'
import { CollectionPage } from 'ywana-core8'
import { USER } from '../../schema'
import './page.css'

const Page = (props) => {

    return (
        <>
            <CollectionPage title="Users" name="Users" schema={USER} url="/users" field="users" actions={[]} autosave={true} />
        </>
    )
}

export default Page